import api from 'api'

export const fetchFields = async (formId) => {
  const { data } = await api.get(`/form/${formId}/fields`)

  return data
}
